/*eslint-disable*/
import React from 'react';

// reactstrap components
import { Container } from 'reactstrap';
// core components

function IndexHeader() {
  let pageHeader = React.createRef();

  return (
    <>
      <div className="page-header clear-filter">
        <a href="/">
          <div
            className="page-header-image"
            style={{
              backgroundImage: 'url(' + require('../../assets/img/background.jpg') + ')',
            }}
            ref={pageHeader}
          ></div>
        </a>

        <Container>
          <div className="content-center brand">
            <h1>Web Development & DevOps</h1>
            <h5>Frontend - Backend - Kubernetes - CI/CD - Cloud</h5>
          </div>
        </Container>
      </div>
    </>
  );
}

export default IndexHeader;
